// PKCE (RFC 7636) helpers. Cognito public clients require S256.

const b64url = (buf: ArrayBuffer): string => {
  const bytes = new Uint8Array(buf);
  let s = '';
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const generateCodeVerifier = (): string => {
  // 32 random bytes → 43-char base64url string. Spec allows 43–128.
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);
  return b64url(bytes.buffer);
};

export const codeChallengeS256 = async (verifier: string): Promise<string> => {
  const data = new TextEncoder().encode(verifier);
  const hash = await window.crypto.subtle.digest('SHA-256', data);
  return b64url(hash);
};

export const randomState = (): string => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return b64url(bytes.buffer);
};
